import FormSearch from './FormSearch.jsx';
import Input from './Input.jsx';

export {
  FormSearch,
  Input
};



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters-old/list-handle-letters-search/index.js